import { render, staticRenderFns } from "./examInformation.vue?vue&type=template&id=732bb74b&scoped=true"
import script from "./examInformation.vue?vue&type=script&lang=js"
export * from "./examInformation.vue?vue&type=script&lang=js"
import style0 from "./examInformation.vue?vue&type=style&index=0&id=732bb74b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732bb74b",
  null
  
)

export default component.exports